export default __webpack_public_path__ + "static/media/t16.min.b20ef021.png";